import React, { useEffect, useState } from 'react';
import { Modal, Button, Checkbox } from 'antd';
import { Card, Row, Col, Typography, Space } from 'antd';
import {
  CheckCircleFilled,
  MessageFilled,
  CalendarOutlined,
  SearchOutlined,
  CalendarFilled,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import Accept from '../../../assets/images/whats_next_accept.png';
import Book from '../../../assets/images/whats_next_book.png';
import Message from '../../../assets/images/whats_next_message.png';
import Search from '../../../assets/images/whats_next_search.png';
import GreenTick from '../../../assets/images/whats_next_green_tick.png';
const { Title, Text } = Typography;

const ActionCard = ({ icon, title, description }) => (
  // <Card size="small"  style={{ borderRadius: '12px', minHeight: '100%'  }}>
  <div
    style={{
      minHeight: '100px',  
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      // backgroundColor:"red"
   
    }}
  >
    {icon}
    <Title level={5} >
      {title}
    </Title>
    <Text type="secondary" style={{ textAlign: 'center' }}>
      {description}
    </Text>
  </div>
  // </Card>
);

const WhatsNextModal = props => {
  const navigate = useNavigate();
  const { visible, setVisible, navigateTo = '', expertName, userId } = props;
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const dispatch = useDispatch();
  const { isDontShowWhatsNext } = useSelector(state => state.common);

  const onCancel = () => {
    setVisible(false);
    if (dontShowAgain) {
      dispatch({ type: 'DONT_SHOW_WHATS_NEXT_MODAL', userId: userId });
      Cookies.set(`dontShowWhatsNext_${userId}`, 'true', { expires: 365 });
    }
    if (navigateTo !== '') {
      navigate(navigateTo);
    }
  };
  useEffect(() => {
    if(Cookies.get(`dontShowWhatsNext_${userId}`) == 'true'){
      setVisible(false);
    }
  },[])
  return (
    <Modal
      className="custom-modal"
      open={visible}
      footer={false}
      centered
      width={800}
      maskClosable={false}
      closeIcon={false}
      closable={false}
    >
      <div style={{ maxWidth: 800, margin: 'auto', padding: 4 }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Space align="center">
            <img width={32} height={32} src={GreenTick} alt="icon" />
            <Title level={3} style={{ margin: 0 }}>
              What’s Next?
            </Title>
          </Space>
          <Text>You still have options — choose what works best for you:</Text>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} lg={6}>
              <ActionCard
                icon={<img width={32}  height={32} src={Accept} alt="icon" />}
                title="Accept"
                description={`Tap to confirm and ${expertName}  will contact you`}
              />
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <ActionCard
                icon={<img width={32} height={32} src={Message} alt="icon" />}
                title="Message"
                description={`Chat with ${expertName}  to ask questions first`}
              />
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <ActionCard
                icon={<img width={32} height={32} src={Book} alt="icon" />}
                title="Book"
                description={`Schedule a virtual meeting with ${expertName} via chat panel`}
              />
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <ActionCard
                icon={<img width={32}  height={32} src={Search} alt="icon" />}
                title="Other Options"
                description="Explore more experts, compare profiles, and choose your fit"
              />
            </Col>
          </Row>

          <Text>🟧 Explore these buttons directly in your dashboard.</Text>

          <Space style={{ justifyContent: 'space-between', width: '100%' }}>
            <Space>
              <Checkbox
                style={{ color: '#4472c4' }}
                onChange={e => setDontShowAgain(e.target.checked)}
              ></Checkbox>
              <Text>Don’t show this message again</Text>
            </Space>

            <Button onClick={() => onCancel()} type="primary">
              Got it
            </Button>
          </Space>
        </Space>
      </div>
    </Modal>
  );
};

export default WhatsNextModal;
